import type { FC, PropsWithChildren, ReactElement } from 'react';
import { useCallback } from 'react';

import { useModifiers } from '../../styles/hooks/useModifiers';

import styles from './Accordion.module.css';

export interface AccordionProps extends PropsWithChildren {
  className?: string;
  header: ReactElement;
  isOpen?: boolean;
  onToggle: (open: boolean) => void;
  /** for storybook testing */
  sectionName?: string;
}

export const Accordion: FC<AccordionProps> = ({
  children,
  className = '',
  header,
  isOpen,
  onToggle,
  sectionName,
}): ReactElement => {
  const handleClick = useCallback(() => {
    onToggle(!isOpen);
  }, [isOpen, onToggle]);

  const mods = useModifiers(styles, 'accordion__body', { open: isOpen }, { withBaseClass: true });

  return (
    <div className={`${styles.accordion} ${className}`}>
      <div
        data-testid="accordion-header"
        className={styles.accordion__header}
        role="button"
        onClick={() => handleClick()}
      >
        {header}
      </div>
      <div data-testid={`accordion-body${sectionName ? `-${sectionName}` : ''}`} className={mods}>
        <div className={styles.accordion__body__wrapper}>{children}</div>
      </div>
    </div>
  );
};
